export default {
  addOns: 'Дополнения',
  all: 'Все',
  browse: 'Обзор',
  buyTickets: 'Купить билеты',
  countSelected: 'Выбрано {{count}}',
  joinWaitlist: 'Присоединиться к списку ожидания',
  joining: 'Присоединение',
  noDatesAvailable: 'Нет доступных дат',
  salesEnded: 'Продажа завершена',
  schedule: 'Расписание',
  seeMoreDates: 'Посмотреть больше дат',
  soldOut: 'Продано',
  about: 'О нас',
  agenda: 'Повестка дня',
  menu: 'Меню',
  included: 'Включено',
  viewMore: 'Посмотреть больше',
  viewLess: 'Посмотреть меньше',
  location: 'Местоположение',
  time: 'Время',
  at: 'в',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Нет доступного времени на эту дату для этого размера группы',
  availableTimes: 'Доступное время',
  waitlist: 'Список ожидания',
  continue: 'Продолжить',
  tickets: 'Билеты',
  ticketsAreNoLongerAvailable: 'Билеты больше не доступны.',
  checkOutOutOtherExperiences: 'Посмотрите наши другие впечатления!',
  viewExperiences: 'Посмотреть впечатления',
  from: 'от',
  cancellationPolicy: 'Политика отмены',
  rsvp: 'RSVP',
  nights: 'ночей',
  request: 'Запрос',
  arrival: 'Прибытие',
  departure: 'Отправление',
};
